import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import SmartRecordsController from '../../controllers/SmartRecordsController';
import styles from './smart-records-panel.module.css';

const RefreshButton: React.FC = () => {
  const controller = useController(SmartRecordsController);
  return (
    <span
      className={styles.recordAction}
      style={{ cursor: 'pointer' }}
      onClick={() => controller.actionInitializePanel()}
    >
      <i className='fa-light fa-arrows-rotate' />
      Refresh
    </span>
  );
};

export default ApplicationView(RefreshButton);
